import { render, staticRenderFns } from "./batchOrderData2.vue?vue&type=template&id=9e597c34&scoped=true&"
import script from "./batchOrderData2.vue?vue&type=script&lang=js&"
export * from "./batchOrderData2.vue?vue&type=script&lang=js&"
import style0 from "./batchOrderData2.vue?vue&type=style&index=0&id=9e597c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e597c34",
  null
  
)

export default component.exports